<template>
  <article :id="id" class="prose-bafsy" :aria-label="ariaLabel">
    <!-- eslint-disable vue/no-v-html -->
    <div v-if="html" v-html="html" />
    <!-- eslint-enable vue/no-v-html -->
    <slot v-else />
  </article>
</template>

<script setup lang="ts">
/**
 * Типографская обёртка для длинных текстов (privacy, blog post).
 *
 * Принимает опциональный `html` (sanitized, произведённый нашим
 * content-pipeline из markdown). Если `html` не задан, рендерит слот,
 * чтобы можно было композировать вручную.
 *
 * Ожидает класс `prose-bafsy`, описанный в `styles/prose.css`.
 * Gen 4 использовал инлайн-селекторы — Gen 6 переносит их в CSS.
 */
interface Props {
  html?: string;
  id?: string;
  ariaLabel?: string;
}

withDefaults(defineProps<Props>(), {
  html: '',
});
</script>
